import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import { DATETIME_FORMAT_FRONTEND, DATE_FORMAT_FRONTEND } from "../../constants";
import TableBase from "./Base";
import { getTranslation } from "../../utils/helper";

const ReportsTable = ({ scrollHeight, setting, roles = [], ...props }) => {
  const COLUMNS = [
    {
      title: getTranslation(setting, "Orders", "Order ID"),
      dataIndex: "orderCode",
      width: 150,
      ellipsis: true,
      fixed: true,
      render(value, record) {
        return (
          <Link to={`/orders/${record._id}`} target="_blank">
            {value}
          </Link>
        );
      },
    },
    {
      title: getTranslation(setting, "Orders", "Order Ref"),
      dataIndex: "orderRef",
      width: 150,
      ellipsis: true,
      fixed: true,
      render(_value, record) {
        return record.orderRef || record.orderCode;
      },
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      width: 150,
      ellipsis: true,
      render(_value, record) {
        return record.routePlan?.company?.name || "-";
      },
    },
    {
      title: getTranslation(setting, "Orders", "Date"),
      dataIndex: "deliveryDate",
      width: 180,
      ellipsis: true,
      render(value) {
        return value ? moment(value).utc().locale(setting.systemLanguage).format(DATE_FORMAT_FRONTEND) : "-";
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Route Plan Name"),
      width: 150,
      ellipsis: true,
      render(row) {
        return row.routePlan?.name || "-";
      },
    },
    {
      title: getTranslation(setting, "Orders", "Pickup Name"),
      dataIndex: "pickupName",
      width: 150,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Orders", "Pickup Address"),
      dataIndex: "pickupAddress",
      width: 250,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Orders", "Pickup Phone"),
      dataIndex: "pickupPhone",
      width: 150,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Orders", "Pickup Time Window"),
      dataIndex: "pickupTimeWindow",
      width: 200,
      ellipsis: true,
      render(_value, record) {
        return (record.timeStart || "") + " - " + (record.timeEnd || "");
      },
    },
    {
      title: getTranslation(setting, "Orders", "Delivery Name"),
      dataIndex: "deliveryName",
      width: 150,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Orders", "Delivery Address"),
      dataIndex: "deliveryAddress",
      width: 250,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Orders", "Delivery Phone"),
      dataIndex: "deliveryPhone",
      width: 150,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Orders", "Delivery Email"),
      dataIndex: "deliveryEmail",
      width: 150,
      ellipsis: true,
      render(value) {
        return <a href={`mailto:${value}`}>{value}</a>;
      },
    },
    {
      title: getTranslation(setting, "Orders", "Delivery Time Window"),
      dataIndex: "deliveryTimeWindow",
      width: 200,
      ellipsis: true,
      render(_value, record) {
        return (record.deliveryTimeStart || "") + " - " + (record.deliveryTimeEnd || "");
      },
    },
    {
      title: getTranslation(setting, "Orders", "User Group"),
      dataIndex: ["group", "name"],
      width: 150,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Orders", "Load"),
      dataIndex: "load",
      width: 100,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Orders", "Date Added"),
      dataIndex: "createdAt",
      width: 180,
      ellipsis: true,
      render(value) {
        return value ? moment(value).locale(setting.systemLanguage).format(DATE_FORMAT_FRONTEND) : "-";
      },
    },
    {
      title: getTranslation(setting, "Orders", "Updated At"),
      dataIndex: "updatedAt",
      width: 240,
      render(value) {
        return value ? moment(value).locale(setting.systemLanguage).format(DATETIME_FORMAT_FRONTEND) : "-";
      },
    },
    {
      title: getTranslation(setting, "Orders", "Status"),
      dataIndex: "status",
      width: 130,
      fixed: "right",
      render() {
        return <span className={"status orderStatus dispatched"}>Dispatched</span>;
      },
    },
  ];

  if (roles.includes("admin")) {
    COLUMNS.splice(3, 0, {
      title: "Company Admin Email",
      dataIndex: "companyName",
      width: 300,
      ellipsis: true,
      render(_value, record) {
        return record.userAdmin?.email || "-";
      },
    });
  }

  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default ReportsTable;
